import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseResponseDTO } from 'src/app/core/models/app.models';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { ApiService } from 'src/app/shared/services/api.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { environment } from 'src/environments/environment';
import { BankAccount, ChangePassword, ConfirmEmail, DocumentModel, VendorModel } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { UserService } from 'src/app/shared/services/user.service';
import { lastValueFrom } from 'rxjs';
import en from 'src/assets/i18n/en';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { CurrencyMaster, User } from 'src/app/shared/models/app.models';
import { FileUploadComponent } from 'src/app/shared/components/file-upload/file-upload.component';
import 'owl.carousel';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DocumentProcessTypes, IconType, VendorStatus } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { attachComments } from '@angular/compiler-cli/src/ngtsc/translator';
import { CarouselComponent } from 'ngx-owl-carousel-o';
 



@Component({
  selector: 'app-bank-account',
  templateUrl: './bank-account.component.html',
  styleUrls: ['./bank-account.component.scss']
})


export class BankAccountComponent  implements OnInit,AfterViewInit  {

  @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;  // Reference the file upload component
  @ViewChild('bankCertificateUpload') bankCertificateUploadComponent!: FileUploadComponent;  // Reference the bank certificate file upload component
  @ViewChild('carousel') carousel: CarouselComponent | undefined;

  
  user : User | null;
  bankAccounts: BankAccount[];
  Countries: any[] = [];

  selectedBankAccount: BankAccount | any;
  bankAccountForm: FormGroup;

  showOtherBank: boolean = false;

  accountInfoForm: FormGroup;
  TempDocumentsArray : DocumentModel[] = [];
  DocumentsArray : DocumentModel[] = [];
  BankCertificateTempArray : DocumentModel[] = [];  // Separate array for bank certificate files
  BankCertificateDocumentsArray : DocumentModel[] = [];  // Array for uploaded bank certificate documents
  uploadPromises: Promise<void>[] = [];  // To track all file upload promises
  bankCertificateUploadPromises: Promise<void>[] = [];  // To track bank certificate file upload promises
  
  returnUrl;
  translations = en;
  invalidSubmit= false;
  AppConstants = AppConstants;

  _PersonalInfoForm: FormGroup;

  Currency: any[] = []; 
  Banks: any[] = [];
  selectedCurrnecy: any;

  isOrganization = false;
  isRegisteredInQNBN = false;
  currentTab: number = 0;
  steps: { title: string }[] = [
    { title: 'Personal Info' },
    { title: 'Account Info' },
  ];

  showUpdateButton: boolean = false;
  showSubmitButton: boolean = true;
  isBankAccountSelected: boolean = false;



  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
   //this.loadScript();
    this.user = this._userService.user;

    const apiService = new ApiService(this._http);  // Manual creation, as per your preference
    apiService.loadAllLookups().then(() => {
      this.Currency = apiService.currencies;  // Access the currencies after lookups are loaded
      this.Banks = apiService.banks;
      this.Countries = apiService.countries || [];
      console.log("BANKS LOOKUP : "+      JSON.stringify(this.Banks));
    }).catch(error => {
      console.error('Failed to load lookups:', error);
    });
    this.initialize();
    this._activeRoute.queryParams.subscribe(params => this.returnUrl = params['returnUrl']);


    
    
  }

  ngAfterViewInit()  {

  }



  getBankDescription(bankName: string): string {
    const bank = this.Banks.find(b => b.bankId === bankName);
    return bank ? bank.description : bankName;  // Return description or 'Unknown Bank' if not found
  }

  async initialize() {
    
    this.initializeForm();
    await this.GetBankAccounts();
    this.applyBankAccountPermissions();

  }

  private loadScript() {
    console.log("Initialization script loaded.");
    
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "../../../../../assets/js/initialization-script.js";
    script.onload = () => {

    }
    document.getElementsByTagName('head')[0].appendChild(script);
    this._loaderService.hideLoader();
  }

  lang: string | null = localStorage.getItem('MSDFLang');

  carouselOptions = {
    loop: false,
    rtl: this.lang === 'ar',
    margin: 30,
    nav: false,
    dots: true,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      1000: { items: 3 }
    }
  };

  nextSlide() {
    this.carousel?.next();
  }

  prevSlide() {
    this.carousel?.prev();
  }
   
  
  // private initializeOwlCarousel(): void {
  //   setTimeout(() => {
  //     $("#bankAccounts-list").owlCarousel({
  //       loop: false,
  //       rtl: this.lang === 'ar',
  //       video: true,
  //       lazyLoad: false,
  //       autoplay: true,
  //       autoplayTimeout: 4000,
  //       margin: 30,
  //       nav: true,  // Enable navigation if needed
  //       dots: true,
  //       responsive: {
  //         0: { items: 1 },
  //         768: { items: 2 },
  //         1000: { items: 3 }
  //       }
  //     });
  //   }, 0); // Timeout ensures the carousel is initialized after DOM update
  // }




  onBankChange(data: any = null): void {
    var selectedValue =  data || this.bankAccountForm.get('bankName')?.value;
    
    if (selectedValue === 'other') {
      this.showOtherBank = true;
      this.bankAccountForm.get('otherBankName')?.setValidators([Validators.required]);
    } else {
      this.showOtherBank = false;
      
      // Clear the value inside 'otherBankName'
      this.bankAccountForm.get('otherBankName')?.reset();
      
      this.bankAccountForm.get('otherBankName')?.clearValidators();
    }
  
    this.bankAccountForm.get('otherBankName')?.updateValueAndValidity();
  }
  



  async GetBankAccounts() {
    let apiService = this.createApiService();
    this._loaderService.showLoader();
  
    let req$ = apiService.get(AppConstants.CONTROLLERS.BankAPI, AppConstants.ACTIONS.GetBankAccounts, true, environment.APIs_PREFIX);
    await lastValueFrom(req$).then((data: any) => {
      let response: BaseResponseDTO = data;
      this.bankAccounts = response.data;
  

  
      // Select the first bank account after sorting
      if (this.bankAccounts.length > 0) {
              // First, sort by bankStatus (ascending)
      this.bankAccounts.sort((a, b) => (a.bankStatus ?? 1) - (b.bankStatus ?? 1));
  
      // Then, sort by ID to get the latest one added (descending)
      this.bankAccounts.sort((a, b) => b.id - a.id);
      
        this.selectBankAccount(this.bankAccounts[0].id);
        this.onBankChange(this.bankAccounts[0].name);
      }
  
      console.log("Sorted bankAccounts:", this.bankAccounts);
    }, (err: HttpErrorResponse) => {
      console.log(err);
    }).finally(() => {
      this._loaderService.hideLoader();
    });
  }
  
  


  private initializeForm() {
    this.bankAccountForm = new FormGroup({
      ExpiryDate: new FormControl(this.selectedBankAccount?.ExpiryDate || ''),
      ActiveDate: new FormControl(this.selectedBankAccount?.ActiveDate || '', Validators.required),
      bankName: new FormControl(this.selectedBankAccount?.bankName || '', Validators.required),
      otherBankName: new FormControl(
        this.selectedBankAccount?.otherBankName || '',
        this.showOtherBank ? Validators.required : null  // Conditionally apply validator
      ),      
      accountNumber: new FormControl(this.selectedBankAccount?.accountNumber || '', [Validators.required, Validators.minLength(5)]),
      iban: new FormControl(this.selectedBankAccount?.iban || '', Validators.required),
      swiftCode: new FormControl(this.selectedBankAccount?.swiftCode || '', Validators.required),
      branchName: new FormControl(this.selectedBankAccount?.branchName || '', Validators.required),
      benficeryName: new FormControl(this.selectedBankAccount?.benficeryName || '', Validators.required),
      //sortCode: new FormControl(this.selectedBankAccount?.sortCode || '', Validators.required),
      bankCountry: new FormControl(this.selectedBankAccount?.bankCountry || '', Validators.required),
      
      email: new FormControl(this.selectedBankAccount?.email || '', Validators.required),
      address: new FormControl(this.selectedBankAccount?.address || '', Validators.required),
      currency: new FormControl(this.selectedBankAccount?.currency || '', Validators.required),
      Document: new FormControl(this.selectedBankAccount?.Document || '', Validators.required),  // Ensure it's a valid value (e.g., base64 or file object)
      bankCertificate: new FormControl(this.selectedBankAccount?.bankCertificate || '', Validators.required),  // Bank Certificate attachment
    });

  }

  onIbanInput(event: any): void {
    const input = event.target as HTMLInputElement;
    // Convert to uppercase and keep only alphanumeric characters
    let value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    // Limit to 34 characters
    if (value.length > 34) {
      value = value.substring(0, 34);
    }
    // Update the form control value
    this.bankAccountForm.get('iban')?.setValue(value, { emitEvent: false });
    // Update the input field value
    input.value = value;
  }

  isBankAccountEditable(bAcc: BankAccount): boolean {
    const allowedStatuses = [VendorStatus.Draft, VendorStatus.Rejected, VendorStatus.Cancelled].map(s => s.toString().toLocaleLowerCase())
    
    return this.canManageBankAccounts
      && this.selectedBankAccount?.id === bAcc.id
      && (allowedStatuses.includes(bAcc?.status?.toString().toLocaleLowerCase() ?? ''));
  }

  get canManageBankAccounts(): boolean {
    return this.user?.ContactType?.toString().toLocaleLowerCase() === 'primary';
  }

  private applyBankAccountPermissions(): void {
    if (this.canManageBankAccounts) {
      return;
    }

    this.showUpdateButton = false;
    this.showSubmitButton = false;
    this.bankAccountForm?.disable({ emitEvent: false });
  }


  get documentFormControl(): FormControl {
    return this.bankAccountForm.get('Document') as FormControl;
  }

  get bankCertificateFormControl(): FormControl {
    return this.bankAccountForm.get('bankCertificate') as FormControl;
  }


  onSubmitBankAccount(){
    if (!this.canManageBankAccounts) {
      this.toastService.error('Only primary contact can add bank account');
      return;
    }

    let result = this.bankAccountForm.valid;

    console.log("form valid :" , result)

    if(result) {
      this._loaderService.showLoader();
      this.SubmitBankAccount().then((result) => {
        if (result.isSuccess) {

        } else {
          console.log('First function returned false, stopping execution');
        }
      }).catch((error) => {
        console.error('Error in first function:', error);
      }).finally(() =>{
        this._loaderService.hideLoader();
    });;
    }
    else {
      this.markFormGroupTouched(this.bankAccountForm);
    }
  }

  public SubmitBankAccount() : Promise<BaseResponseDTO> {

    console.log("bankAccountForm from: " , this.bankAccountForm);
    console.log("this.registrationForm.getRawValue() " , this.bankAccountForm.getRawValue());
    const apiService = this.createApiService();


    // Include existing uploaded documents with FileContent (needed for backend to re-upload after deletion)
    let filteredDocuments = this.DocumentsArray.map(element => ({
      AttachmentFor: element.AttachmentFor,
      Name: element.Name,
      FileContent: (element.FileContent && !String(element.FileContent).startsWith('http')) ? element.FileContent : '',
      MimeType: element.MimeType,
      ProcessName: element.ProcessName,
      AttachmentId: element.AttachmentId,
      ApplicationId: this.user?.Id || '',
      FilePath: element.FilePath  // Keep FilePath for reference
    }));

    // Include existing bank certificate documents with FileContent (needed for backend to re-upload after deletion)
    let filteredBankCertificateDocuments = this.BankCertificateDocumentsArray.map(element => ({
      AttachmentFor: element.AttachmentFor,
      Name: element.Name,
      FileContent: (element.FileContent && !String(element.FileContent).startsWith('http')) ? element.FileContent : '',
      MimeType: element.MimeType,
      ProcessName: element.ProcessName,
      AttachmentId: element.AttachmentId,
      ApplicationId: this.user?.Id || '',
      FilePath: element.FilePath  // Keep FilePath for reference
    }));

    // Include new Company Bank Details files from TempArray (for new bank accounts)
    // Keep FileContent since these files haven't been uploaded yet - backend needs it
    let filteredTempDocuments: any[] = [];
    if (this.TempDocumentsArray.length > 0) {
      // Set AttachmentId to '0' for new bank accounts (will be set by backend after creation)
      this.TempDocumentsArray.forEach(doc => {
        doc.AttachmentId = '0';
        doc.ApplicationId = this.user?.Id || '';
      });
      
      // Include FileContent for new files that haven't been uploaded yet
      filteredTempDocuments = this.TempDocumentsArray.map(element => ({
        AttachmentFor: element.AttachmentFor,
        Name: element.Name,
        FileContent: element.FileContent,  // Keep FileContent for new files
        MimeType: element.MimeType,
        ProcessName: element.ProcessName,
        AttachmentId: element.AttachmentId,
        ApplicationId: element.ApplicationId
      }));
    }

    // Include new bank certificate files from TempArray (for new bank accounts)
    // Keep FileContent since these files haven't been uploaded yet - backend needs it
    let filteredBankCertificateTempDocuments: any[] = [];
    if (this.BankCertificateTempArray.length > 0) {
      // Set AttachmentId to '0' for new bank accounts (will be set by backend after creation)
      this.BankCertificateTempArray.forEach(cert => {
        cert.AttachmentId = '0';
        cert.ApplicationId = this.user?.Id || '';
      });
      
      // Include FileContent for new files that haven't been uploaded yet
      filteredBankCertificateTempDocuments = this.BankCertificateTempArray.map(element => ({
        AttachmentFor: element.AttachmentFor,
        Name: element.Name,
        FileContent: element.FileContent,  // Keep FileContent for new files
        MimeType: element.MimeType,
        ProcessName: element.ProcessName,
        AttachmentId: element.AttachmentId,
        ApplicationId: element.ApplicationId,
        FilePath: element.FilePath || ''  // New files don't have FilePath yet
      }));
    }

    let newBankAccount = {
      name : this.bankAccountForm.controls['bankName'].value,
      accountNumber : this.bankAccountForm.controls['accountNumber'].value,
      bankIBAN : this.bankAccountForm.controls['iban'].value,
      swift : this.bankAccountForm.controls['swiftCode'].value,
      branch : this.bankAccountForm.controls['branchName'].value,
      beneficiaryName : this.bankAccountForm.controls['benficeryName'].value,
      email : this.bankAccountForm.controls['email'].value,
      address : this.bankAccountForm.controls['address'].value,
      currencyCode : this.bankAccountForm.controls['currency'].value,
      ActiveDate : this.bankAccountForm.controls['ActiveDate'].value,
      ExpiryDate : this.bankAccountForm.controls['ExpiryDate'].value,
      //sortCode : this.bankAccountForm.controls['sortCode'].value,
      Documents : [...filteredDocuments, ...filteredTempDocuments, ...filteredBankCertificateDocuments, ...filteredBankCertificateTempDocuments],  // Include all document types
      bankCountry : this.bankAccountForm.controls['bankCountry'].value,
      
      otherBankName : this.bankAccountForm.controls['otherBankName'].value,
      vendorID : this.user?.Id,
    }

    console.log("newbankAccount " , newBankAccount);

    return new Promise((resolve, reject) => {

        this.firePostBankAccount(apiService,newBankAccount)
        .then(async (result: any) => {
          let response: BaseResponseDTO = result;

          if (response?.isSuccess){
            // Bank certificate files are already included in the Documents array
            // No need for separate upload - they are handled by the create API
            
            // this.loadScript();
            // this.GetBankAccounts();
            window.location.reload();
            this._dialogService.showDialog('Bank Submission','Successfuly Added',IconType.Success);

            this.bankAccountForm.reset();
            this.DocumentsArray = [];
            this.BankCertificateTempArray = [];
            this.BankCertificateDocumentsArray = [];
            //this._dialogService.showDialog("Success" , "Updated Successfully");
          }
          else{
            this._loaderService.hideLoader();
            this._dialogService.showDialog("Bank Submission" , response.errorMessageEn,IconType.Warning);
          }
          resolve(response);

        }).catch((err: HttpErrorResponse) => {
            this._loaderService.hideLoader();
            this._dialogService.showDialog("Bank Submission" , "something Went Wrong",IconType.Error);
        }).finally(() =>{
            this._loaderService.hideLoader();
        });

    });

  }

  private firePostBankAccount(apiService: ApiService, payload: any) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.BankAPI, AppConstants.ACTIONS.SubmitBankAccount, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }


  async selectBankAccount(bankAccountId: any): Promise<void> {
    this.bankAccountForm.disable();
    this.DocumentsArray =[];
    this.TempDocumentsArray =[];
    this.BankCertificateDocumentsArray = [];
    this.BankCertificateTempArray = [];
    // this.selectedBankAccount = {};
    let account = this.bankAccounts.find(b => b.id == bankAccountId);
    if (account != null){
      this.selectedBankAccount  = account;
      this.isBankAccountSelected = true;
      this.showUpdateButton = false;
      this.showSubmitButton = false;
    }

    console.log("selected bank acc :" , this.selectedBankAccount);
    this.bankAccountForm.reset();

    this.bankAccountForm.patchValue({
      accountNumber: this.selectedBankAccount?.accountNumber,
      iban: this.selectedBankAccount?.bankIBAN,
      swiftCode: this.selectedBankAccount?.swift,
      branchName: this.selectedBankAccount?.branch,
      benficeryName: this.selectedBankAccount?.beneficiaryName,
//      sortCode: this.selectedBankAccount?.sortCode,  // You may need to handle this if it matches another property
      
bankCountry : this.selectedBankAccount?.bankCountry,

      address: this.selectedBankAccount?.address,
      currency: this.selectedBankAccount?.currencyCode,
      bankName: this.selectedBankAccount?.name,  // Assuming bankName maps to 'name' in BankFieldsDTO
      email : this.selectedBankAccount?.email,
      otherBankName : this.selectedBankAccount?.otherBankName,
      ActiveDate: this.formatDate(this.selectedBankAccount?.activeDate),
      ExpiryDate: this.formatDate(this.selectedBankAccount?.expiryDate),
    });
    this.fileUploadComponent.clearUploadedFiles();
    if (this.bankCertificateUploadComponent) {
      this.bankCertificateUploadComponent.clearUploadedFiles();
    }
    
    if (this.selectedBankAccount.document && this.selectedBankAccount.document.length > 0) {
      for (const doc of this.selectedBankAccount.document) {
        const mimeType = doc.mimeType || 'application/pdf';
        const fileContent = doc.fileContent ?? doc.FileContent;
        const blob = await this.getBlobFromFileContent(fileContent, mimeType);
        const storedFileContent = fileContent ?? '';

        if (doc.attachmentFor === 'bankCertificate') {
          if (blob && this.bankCertificateUploadComponent) {
            this.bankCertificateUploadComponent.pushFileToUploadedFiles(doc.name, blob, mimeType);
          }
          this.BankCertificateDocumentsArray.push({
            AttachmentFor: doc.attachmentFor,
            Name: doc.name,
            MimeType: doc.mimeType,
            FilePath: doc.filePath,
            ProcessName: doc.processName,
            AttachmentId: this.selectedBankAccount.id.toString(),
            FileContent: storedFileContent
          });
        } else {
          if (blob) {
            this.fileUploadComponent.pushFileToUploadedFiles(doc.name, blob, mimeType);
          }
          this.DocumentsArray.push({
            AttachmentFor: doc.attachmentFor,
            Name: doc.name,
            MimeType: doc.mimeType,
            FilePath: doc.filePath,
            ProcessName: doc.processName,
            AttachmentId: this.selectedBankAccount.id.toString(),
            FileContent: storedFileContent
          });
        }
      }
    }
    
    

    


  }

  formatDate(dateString: string): string | null {
    if (!dateString) return null;

    // API may return "dd/MM/yyyy hh:mm:ss am/pm" — JS Date parses slashes as MM/dd,
    // so parse the day/month/year parts manually for this format
    const dmyMatch = String(dateString).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    const date = dmyMatch
      ? new Date(Number(dmyMatch[3]), Number(dmyMatch[2]) - 1, Number(dmyMatch[1]))
      : new Date(dateString);

    if (isNaN(date.getTime())) return null; // Invalid date - avoid "NaN-aN-aN"
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Add leading zero
    const day = ('0' + date.getDate()).slice(-2);  // Add leading zero
    return `${year}-${month}-${day}`;  // Return in "YYYY-MM-DD" format
  }

  /** Get a Blob from FileContent (Azure blob SAS URL or base64). Used when API returns URL instead of base64. */
  async getBlobFromFileContent(fileContent: string | null | undefined, mimeType: string): Promise<Blob | null> {
    if (!fileContent) return null;
    if (typeof fileContent === 'string' && (fileContent.startsWith('http://') || fileContent.startsWith('https://'))) {
      try {
        const response = await fetch(fileContent, { method: 'GET' });
        if (!response.ok) return null;
        return await response.blob();
      } catch {
        return null;
      }
    }
    const base64String = fileContent.includes('base64,') ? fileContent.split(',')[1] : fileContent;
    if (!base64String) return null;
    try {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const uint8Array = new Uint8Array(byteNumbers);
      return new Blob([uint8Array], { type: mimeType });
    } catch {
      return null;
    }
  }

    // Call this method to update a bank account
    updateSelectedBankAccount(bankAccountId: any): void {
      if (!this.canManageBankAccounts) {
        this.toastService.error('Only primary contact can update bank account');
        return;
      }

      this.showUpdateButton = true;
      this.showSubmitButton = false;
      this.isBankAccountSelected = false;
      console.log(`Update bank account with ID: ${bankAccountId}`);
      // Implement your update logic here
      this.bankAccountForm.enable();
    }



    onAddNewBankAccount() {
      if (!this.canManageBankAccounts) {
        this.toastService.error('Only primary contact can add bank account');
        return;
      }

      this.DocumentsArray =[];
      this.TempDocumentsArray = [];
      this.BankCertificateDocumentsArray = [];
      this.BankCertificateTempArray = [];
      this.showUpdateButton = false;
      this.showSubmitButton = true;
      this.isBankAccountSelected = false;
      this.selectedBankAccount = null; // Clear selection
      this.bankAccountForm.enable();
      this.bankAccountForm.reset();
      this.fileUploadComponent.clearUploadedFiles();
      if (this.bankCertificateUploadComponent) {
        this.bankCertificateUploadComponent.clearUploadedFiles();
      }
    }


  onUpdateBankAccount(){
    if (!this.canManageBankAccounts) {
      this.toastService.error('Only primary contact can update bank account');
      return;
    }


    console.log("selected account : ", this.selectedBankAccount);

    if (!this.selectedBankAccount){
      
      this.toastService.error('Please Select account to Update');
      return;
    }

    let result = this.bankAccountForm.valid;

    console.log("form valid :" , result)

    if(result) {

      this._loaderService.showLoader();
      this.updateBankAccount().then((result) => {
        if (result.isSuccess) {

        } else {
          console.log('First function returned false, stopping execution');
        }
      }).catch((error) => {
        console.error('Error in first function:', error);
      }).finally(() =>{
        this._loaderService.hideLoader();
    });
    }
    else {
      this.markFormGroupTouched(this.bankAccountForm);
    }
  }

  public updateBankAccount() : Promise<BaseResponseDTO> {

    console.log("bankAccountForm from: " , this.bankAccountForm);
    console.log("this.registrationForm.getRawValue() " , this.bankAccountForm.getRawValue());
    const apiService = this.createApiService();

    // Include existing uploaded documents with FileContent (needed for backend to re-upload after deletion)
    let filteredDocuments = this.DocumentsArray.map(element => ({
      AttachmentFor: element.AttachmentFor,
      Name: element.Name,
      FileContent: (element.FileContent && !String(element.FileContent).startsWith('http')) ? element.FileContent : '',
      MimeType: element.MimeType,
      ProcessName: element.ProcessName,
      AttachmentId: element.AttachmentId,
      ApplicationId: this.user?.Id || '',
      FilePath: element.FilePath  // Keep FilePath for reference
    }));

    // Include existing bank certificate documents with FileContent (needed for backend to re-upload after deletion)
    let filteredBankCertificateDocuments = this.BankCertificateDocumentsArray.map(element => ({
      AttachmentFor: element.AttachmentFor,
      Name: element.Name,
      FileContent: (element.FileContent && !String(element.FileContent).startsWith('http')) ? element.FileContent : '',
      MimeType: element.MimeType,
      ProcessName: element.ProcessName,
      AttachmentId: element.AttachmentId,
      ApplicationId: this.user?.Id || '',
      FilePath: element.FilePath  // Keep FilePath for reference
    }));

    // Include new Company Bank Details files from TempArray
    // Keep FileContent since these files haven't been uploaded yet - backend needs it
    let filteredTempDocuments: any[] = [];
    if (this.TempDocumentsArray.length > 0) {
      // Update AttachmentId for new Company Bank Details files
      this.TempDocumentsArray.forEach(doc => {
        doc.AttachmentId = this.selectedBankAccount.id.toString();
        doc.ApplicationId = this.user?.Id || '';
      });
      
      // Include FileContent for new files that haven't been uploaded yet
      filteredTempDocuments = this.TempDocumentsArray.map(element => ({
        AttachmentFor: element.AttachmentFor,
        Name: element.Name,
        FileContent: element.FileContent,  // Keep FileContent for new files
        MimeType: element.MimeType,
        ProcessName: element.ProcessName,
        AttachmentId: element.AttachmentId,
        ApplicationId: element.ApplicationId
      }));
    }

    // Also include any new bank certificate files from TempArray
    // Keep FileContent since these files haven't been uploaded yet - backend needs it
    if (this.BankCertificateTempArray.length > 0) {
      // Update AttachmentId for new bank certificate files
      this.BankCertificateTempArray.forEach(cert => {
        cert.AttachmentId = this.selectedBankAccount.id.toString();
        cert.ApplicationId = this.user?.Id || '';
      });
      
      // Include FileContent for new files that haven't been uploaded yet
      const newBankCertDocs = this.BankCertificateTempArray.map(element => ({
        AttachmentFor: element.AttachmentFor,
        Name: element.Name,
        FileContent: element.FileContent ?? '',
        MimeType: element.MimeType,
        ProcessName: element.ProcessName,
        AttachmentId: element.AttachmentId,
        ApplicationId: element.ApplicationId || this.user?.Id || '',
        FilePath: element.FilePath || ''
      }));
      filteredBankCertificateDocuments = [...filteredBankCertificateDocuments, ...newBankCertDocs];
    }

    let newBankAccount = {
      name : this.bankAccountForm.controls['bankName'].value,
      accountNumber : this.bankAccountForm.controls['accountNumber'].value,
      bankIBAN : this.bankAccountForm.controls['iban'].value,
      swift : this.bankAccountForm.controls['swiftCode'].value,
      branch : this.bankAccountForm.controls['branchName'].value,
      beneficiaryName : this.bankAccountForm.controls['benficeryName'].value,
      email : this.bankAccountForm.controls['email'].value,
      address : this.bankAccountForm.controls['address'].value,
      currencyCode : this.bankAccountForm.controls['currency'].value,
      ActiveDate : this.bankAccountForm.controls['ActiveDate'].value,
      ExpiryDate : this.bankAccountForm.controls['ExpiryDate'].value,
      //sortCode : this.bankAccountForm.controls['sortCode'].value,
      bankCountry : this.bankAccountForm.controls['bankCountry'].value,
      Documents : [...filteredDocuments, ...filteredTempDocuments, ...filteredBankCertificateDocuments],  // Include all document types
      otherBankName : this.bankAccountForm.controls['otherBankName'].value,
      vendorID : this.user?.Id,
      ID : this.selectedBankAccount.id,
    } 

    console.log("newbankAccount " , newBankAccount);

    return new Promise((resolve, reject) => {
  
        this.firePutBankAccount(apiService,newBankAccount)
        .then((result: any) => {
          let response: BaseResponseDTO = result;

          if (response?.isSuccess){
            // Bank certificate files are already included in the Documents array
            // No need for separate upload - they are handled by the update API
            
            // this.loadScript();
            // this.GetBankAccounts();
            window.location.reload();
            this._dialogService.showDialog('Update Bank','Successfuly Updated',IconType.Success);
            this.bankAccountForm.reset();
            this.DocumentsArray = [];
            this.BankCertificateTempArray = [];
            this.BankCertificateDocumentsArray = [];
          }
          else{

            this._dialogService.showDialog('Update Bank' , response.errorMessageEn,IconType.Error);
          }
          resolve(response);

        }).catch((err: HttpErrorResponse) => {

          this._dialogService.showDialog('Update Bank' , "something Went Wrong",IconType.Error);

        }).finally(() =>{
            this._loaderService.hideLoader();
        });

    });

  }

  private firePutBankAccount(apiService: ApiService, payload: any) {
    let req$ = apiService.put(AppConstants.CONTROLLERS.BankAPI, AppConstants.ACTIONS.UpdateBankDetailsByVendorID, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  }











 
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

    //#region API Service
    private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion



    //////////////////////////// handle file 

    

  handleFileUpload(event: { name: string, file: File, fileType: string }, documentName?: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const reader = new FileReader();
  
  
      // Read the file as a Data URL (which includes the Base64 string with MIME type)
      reader.readAsDataURL(event.file as Blob);
  
      reader.onload = () => {
        const base64String = reader.result as string; // This contains 'data:image/png;base64,...'
  
        // Check if this is a bank certificate upload
        if (documentName === 'bankCertificate') {
          // Push to BankCertificateTempArray
          this.BankCertificateTempArray.push({
            AttachmentFor: documentName,
            Name: event.name,
            FileContent: base64String,  // Base64 string with MIME type
            MimeType: event.fileType,
            ProcessName: DocumentProcessTypes.VendorBank.toString(),
            AttachmentId: this.selectedBankAccount != null ? this.selectedBankAccount.id.toString() : '0',
            ApplicationId: this.user?.Id || ''
          });
        } else {
          // Push the document to TempDocumentsArray (for Company Bank Details)
          this.TempDocumentsArray.push({
            AttachmentFor: documentName,
            Name: event.name,
            FileContent: base64String,  // Base64 string with MIME type
            MimeType: event.fileType,
            ProcessName: DocumentProcessTypes.VendorBank.toString(),
            AttachmentId:  this.selectedBankAccount != null  ? this.selectedBankAccount.id.toString() : '0',
            ApplicationId: this.user?.Id || ''
          });
        }

        
  
        resolve(); // Resolve the promise when the file has been processed
      };
  
      reader.onerror = (error) => {
        console.error('Error converting file to Base64: ', error);
        reject(error); // Reject the promise on error
      };
    });
  }
  
  
  onFileUpload(event: { name: string, file: File, fileType: string }, documentName?: string): void {
    // Track the promise for this upload
    const uploadPromise = this.handleFileUpload(event, documentName);
    
    // Add the promise to appropriate array based on document type
    if (documentName === 'bankCertificate') {
      this.bankCertificateUploadPromises.push(uploadPromise);
    } else {
      this.uploadPromises.push(uploadPromise);
    }
  }
  

  async onAllFilesUploaded(): Promise<void> {
    try {
      // Wait for all file upload promises to resolve before proceeding
      await Promise.all(this.uploadPromises);
  
      // Company Bank Details files are stored in TempDocumentsArray
      // They will be uploaded when creating or updating the bank account
      // No immediate upload - files are included in the Documents array during submit/update
      this.uploadPromises = [];
    } catch (error) {
      // Handle errors during file processing
      this.TempDocumentsArray = [];
      this.uploadPromises = [];
      console.error('Error processing files:', error);
    }
  }

  // Separate handler for bank certificate file uploads
  async onBankCertificateFilesUploaded(): Promise<void> {
    try {
      // Wait for all bank certificate file upload promises to resolve
      await Promise.all(this.bankCertificateUploadPromises);
      
      // Bank certificate files are stored in BankCertificateTempArray
      // They will be uploaded when creating or updating the bank account
      // No immediate upload - files are included in the Documents array during submit/update
      this.bankCertificateUploadPromises = [];
    } catch (error) {
      // Handle errors during file processing
      this.BankCertificateTempArray = [];
      this.bankCertificateUploadPromises = [];
      console.error('Error processing bank certificate files:', error);
    }
  }






 
   handleFileRemove(documentName: string, fileName: string): void {
    if (!fileName) {
      console.error('No file name provided for removal');
      return;
    }
  
    console.log(`Removing file: ${fileName} for document: ${documentName}`);
  
    // Check if this is a bank certificate removal
    if (documentName === 'bankCertificate') {
      // First check if it's in the uploaded documents array
      const attachmentIndex = this.BankCertificateDocumentsArray.findIndex(
        att => att.Name === fileName
      );
      
      if (attachmentIndex !== -1) {
        // Remove from uploaded documents array (will be excluded from submit/update)
        this.BankCertificateDocumentsArray.splice(attachmentIndex, 1);
        // Remove from file upload component UI
        if (this.bankCertificateUploadComponent) {
          const fileToRemove = this.bankCertificateUploadComponent.uploadedFiles.find(f => f.name === fileName);
          if (fileToRemove) {
            this.bankCertificateUploadComponent.removeFile(fileToRemove);
          }
        }
        this.toastService.success('Bank certificate removed. Changes will be saved when you submit/update the bank account.');
      } else {
        // If not in DocumentsArray, remove from TempArray (not yet uploaded)
        const tempIndex = this.BankCertificateTempArray.findIndex(
          att => att.Name === fileName
        );
        if (tempIndex !== -1) {
          this.BankCertificateTempArray.splice(tempIndex, 1);
          // Remove from file upload component UI
          if (this.bankCertificateUploadComponent) {
            const fileToRemove = this.bankCertificateUploadComponent.uploadedFiles.find(f => f.name === fileName);
            if (fileToRemove) {
              this.bankCertificateUploadComponent.removeFile(fileToRemove);
            }
          }
          this.toastService.success('Bank certificate removed.');
        }
      }
    } else {
      // Find the index of the file in DocumentsArray based on the name
      const attachmentIndex = this.DocumentsArray.findIndex(
        att => att.Name === fileName
      );
    
      if (attachmentIndex !== -1) {
        // Remove from uploaded documents array (will be excluded from submit/update)
        this.DocumentsArray.splice(attachmentIndex, 1);
        // Remove from file upload component UI
        const fileToRemove = this.fileUploadComponent.uploadedFiles.find(f => f.name === fileName);
        if (fileToRemove) {
          this.fileUploadComponent.removeFile(fileToRemove);
        }
        this.toastService.success('File removed. Changes will be saved when you submit/update the bank account.');
      } else {
        // Check if it's in TempDocumentsArray (not yet uploaded)
        const tempIndex = this.TempDocumentsArray.findIndex(
          att => att.Name === fileName
        );
        if (tempIndex !== -1) {
          this.TempDocumentsArray.splice(tempIndex, 1);
          // Remove from file upload component UI
          const fileToRemove = this.fileUploadComponent.uploadedFiles.find(f => f.name === fileName);
          if (fileToRemove) {
            this.fileUploadComponent.removeFile(fileToRemove);
          }
          this.toastService.success('File removed.');
        } else {
          console.warn(`File not found: ${fileName}`);
        }
      }
    }
  }

  





 






   // Convert base64 string to Blob
   base64ToBlob(base64: string, contentType: string = ''): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }


private firePostDocuments(apiService: ApiService, payload: any ) {
  let req$ = apiService.post(AppConstants.CONTROLLERS.Documents, AppConstants.ACTIONS.UploadDocumnets, true, environment.APIs_PREFIX, payload);
  return lastValueFrom(req$);
}


private fireDeletePostDocuments(apiService: ApiService, payload: any ) {
  let req$ = apiService.post(AppConstants.CONTROLLERS.Documents, AppConstants.ACTIONS.RemoveDocument, true, environment.APIs_PREFIX, payload);
  return lastValueFrom(req$);
}


  






}



